import { Button, DatePicker } from "antd";
import moment, { Moment } from "moment";
import { useHistory } from "react-router-dom";

export default function MyOrdersHeader({
  path,
  tabKey,
  setOrderStatus,
  orderStatus,
  selectedDate,
  setSelectedDate,
}: {
  path: string;
  tabKey: string;
  setOrderStatus: (value: string) => void;
  orderStatus: string;
  selectedDate: Moment | null;
  setSelectedDate: any;
}) {
  const history = useHistory();
  return (
    <div className="my_orders_header">
      <div className="my_orders_header_left">
        <h1>my orders</h1>
        <div className="my_orders_header_btns mt-2 mt-md-0">
          <Button
            type="ghost"
            onClick={() => {
              history.push(`${path}/${tabKey}/in-progress`);
              setOrderStatus("in-progress");
            }}
            className={orderStatus === "in-progress" ? "--selected" : ""}
          >
            In progress
          </Button>
          <Button
            type="ghost"
            onClick={() => {
              history.push(`${path}/${tabKey}/cancelled`);
              setOrderStatus("cancelled");
            }}
            className={orderStatus === "cancelled" ? "--selected" : ""}
          >
            Cancelled
          </Button>
        </div>
      </div>
      <div className="my_orders_header_right mt-2 mt-md-0">
        <span className="mr-2" onClick={() => setSelectedDate(null)}>
          See All
        </span>
        <DatePicker
          className="date_my_orders"
          // @ts-ignore
          defaultValue={selectedDate || ""}
          format={"DD/MM/YYYY"}
          onChange={(date: any, dateString: any) => setSelectedDate(dateString)}
        />
      </div>
    </div>
  );
}
